import React from "react";
import AccessibilityMenu from "../AccessibilityMenu/accessibilityMenu"

function TopBaner() {
  return (
    <div className="topBar">
      <AccessibilityMenu />

      <div className="webTopBar" style={{ margin: "0 auto" }}>
        <div>
          <img
            style={{ height: "150px", width: "260px", marginLeft: "20px", marginTop: "30px" }}
            src="/pycBlueIogo.png"
            alt="logo-pych"
          />
          <p style={{ textAlign: "center", fontWeight: "bold", color: "#488bc9", fontSize: "17px", marginLeft: "30px" }}>
            שירות הסעות בכל רחבי אירופה
          </p>
        </div>
      </div>

      <div className="topBarImagesMobile">
        <img
          style={{ width: "230px", marginTop: "60px", height: "100px", marginLeft: "80px", marginRight: "70px" }}
          src="pycBlueIogo.png"
          alt="logo-pych"
        />
      </div>

      <p
        style={{
          position: "absolute",
          top: 0,
          right: 0,
          textAlign: "right",
          margin: "20px",
        }}
      >
        בס"ד
      </p>
    </div>
  );
}

export default TopBaner;
